<template>
  <Modal
    :id="id"
    :title="course.name || 'Online Course Enrollment'"
    :hideClose="true"
    :hideFooter="true"
  >
    <div slot="body" class="modal-body modal-form">
      <FormWrapper v-if="series" :action="formAction" method="POST">
        <input type="hidden" name="series_id" :value="series.id" />
        <div class="instructions">
          <p>
            This course is available as part of the "{{ series.name }}" series.
            Please select any additional courses for which you would like to
            register.
          </p>
          <p v-if="series.discount_amount > 0">
            You will receive a discount of {{ series.discount }} your total if
            you purchase the entire series.
          </p>
          <p>
            NOTE: The course expiration period is defined in the course details.
            This time period begins on the date of purchase. For additional
            information, please review our
            <a
              :href="route('enroll.online.purchase-policy')"
              target="_blank"
              class="text-primary"
              >Online Training Purchase Policy</a
            >.
          </p>
        </div>
        <div class="series-courses mb-4">
          <Field
            v-for="(sc, i) in seriesCourses"
            :key="`cb_series_course_${i}`"
            type="checkbox"
            :id="`cb_series_course_${i}`"
            name="series_courses[]"
            :label="sc.name"
            :value="self && sc.in_queue"
            :checkbox-value="sc.id"
          />
        </div>
        <div class="buttons text-center">
          <button type="submit" class="btn btn-success mr-1">Continue</button>
          <a class="btn btn-info ml-1" href="#" @click.prevent="close"
            >Cancel</a
          >
        </div>
      </FormWrapper>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "series-enrollment-modal",
      course: null,
      series: null,
      self: false,
    };
  },
  computed: {
    formAction() {
      var route = this.self
        ? "enroll.online.course.self"
        : "enroll.online.course.others";
      return this.route(route, { course: this.course.id });
    },
    seriesCourses() {
      if (!this.series || !this.series.courses) return [];
      return this.series.courses.filter((sc) => {
        return sc.id !== this.course.id && this.canEnroll(sc);
      });
    },
  },
  methods: {
    load() {
      this.axios
        .get(
          this.route("enroll.online.series", { series: this.course.series_id })
        )
        .then((response) => {
          this.series = response.data;
        });
    },
    canEnroll(course) {
      return (
        (this.self && !!course.can_enroll) ||
        (!this.self && !!course.can_enroll_others)
      );
    },
  },
  created() {
    this.course = this.options.course;
    this.self = !!this.options.self || false;
  },
  mounted() {
    this.load();
  },
};
</script>